<template>
  <div>
    <b-img
      :src="require('@/assets/images/logo_centered.svg')"
      width="300"
      class="rounded-0"
    />

    <div class="mt-4">
      <h4 class="font-weight-bold">Reset Password</h4>
      <p class="mt-3">
        Enter your email address to receive an email with a code to
        <br />reset your password:
      </p>
    </div>

    <b-form class="mt-4" @submit.prevent="onSubmit">
      <b-form-group id="input-group-1" class="col-12">
        <b-form-input
          id="input-1"
          v-model="form.email"
          class="input-effect"
          :class="form.email ? 'has-content' : ''"
          type="email"
          required
          disabled
        ></b-form-input>
        <label>Email address</label>
      </b-form-group>

      <b-form-group id="input-group-2" class="col-12">
        <i class="clearable" v-show="form.token" @click="form.token = ''"
          >&times;</i
        >
        <b-form-input
          id="input-2"
          v-model="form.token"
          class="input-effect"
          :class="form.token ? 'has-content' : ''"
          type="text"
          required
          autofocus
        ></b-form-input>
        <label>Reset code</label>
        <div class="input-error" v-if="form.$getError('token')">
          {{ form.$getError('token')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-3" class="col-12">
        <i class="clearable" v-show="form.password" @click="form.password = ''"
          >&times;</i
        >
        <b-form-input
          id="input-3"
          v-model="form.password"
          class="input-effect"
          :class="form.password ? 'has-content' : ''"
          type="password"
          autocomplete="new-password"
          required
        ></b-form-input>
        <label>New password</label>
        <div class="input-error" v-if="form.$getError('password')">
          {{ form.$getError('password')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-4" class="col-12">
        <i
          class="clearable"
          v-show="form.password_confirmation"
          @click="form.password_confirmation = ''"
          >&times;</i
        >
        <b-form-input
          id="input-4"
          v-model="form.password_confirmation"
          class="input-effect"
          :class="form.password_confirmation ? 'has-content' : ''"
          type="password"
          autocomplete="new-password"
          required
        ></b-form-input>
        <label>Re-enter new password</label>
        <div class="input-error" v-if="form.$getError('password_confirmation')">
          {{ form.$getError('password_confirmation')[0] }}
        </div>
      </b-form-group>

      <div class="ta-right mt-4">
        <b-button type="submit" variant="primary" block>
          <b-spinner class="mr-2" small v-if="form.$busy"></b-spinner>Submit
        </b-button>
      </div>

      <div class="ta-center mt-4">
        <b-link class="form-link" @click.prevent="onResendCode"
          >Didn't receive a code?</b-link
        >
      </div>
    </b-form>
  </div>
</template>

<script>
import Form from '@/utils/form'

export default {
  data() {
    return {
      form: new Form({
        email: '',
        token: '',
        password: '',
        password_confirmation: ''
      })
    }
  },

  methods: {
    async onSubmit(evt) {
      this.form.$busy = false
      await this.$api
        .post('auth/reset-password', {
          email: this.form.email,
          token: this.form.token,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.$router.replace({ name: 'auth.login-page' })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    },
    async onResendCode(evt) {
      this.form.$busy = true
      await this.$api
        .post('auth/forgot-password', {
          email: this.form.email
        })
        .then(({ data }) => {
          this.form.$busy = false
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    }
  },

  created() {
    this.form.email = this.$route.params.email
  },

  watch: {
    'form.token'() {
      this.form.$clearError('token')
    },
    'form.password'() {
      this.form.$clearError('password')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-link {
  font-weight: bold;
}
</style>
